import React from 'react';
import ModuloTemplate from '../Elements/ModuloTemplate';

const bnrimg = require('../../images/sec1.jpg');
const productImg = require('../../images/Administracion_del_sistema.png');

const AdminModule = () => (
    <ModuloTemplate
        moduleKey="admin"
        bnrimg={bnrimg}
        productImg={productImg}
    />
);

export default AdminModule;
